import React from "react";
import Rope from "../images/Rope.png";
import Logo from "../images/Logo.png";
import Logo1 from "../images/Logo1.png";
import Logo2 from "../images/Logo2.png";
import Logo3 from "../images/Logo3.png";
import Logo4 from "../images/Logo4.png";

const About = () => {
  return (
    <div className=" py-5">
      <h1 className="font-merienda  block 5xl:hidden text-center mt-6 text-[27px] mb-6">
        Our Story
      </h1>
      <div className="5xl:flex">
        <div className="px-5 mb-7">
          {/* Mobile view video */}
          <div className="5xl:hidden block">
            <div className="aspect-w-24 aspect-h-12  w-full   ">
              <iframe
                className="p-6 w-full h-[170px] xs:h-[190px] sm:h-[230px] md:h-[300px] lg:h-[320px] xl:h-[340px] 2xl:h-[360px]  rounded"
                src="https://www.youtube.com/embed/yc6lg5h6M0g"
                title="YouTube video"
                style={{ border: "0" }}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
        {/* Desktop view video */}
        <div className="hidden 5xl:block">
          <iframe
            className=" mt-10 5xl:w-[400px] h-[360px] 6xl:w-[460px] 7xl:w-[540px] 8xl:w-[600px] 8xl:h-[400px] 9xl:w-[670px] 9xl:h-[430px] 10xl:w-[980px] 10xl:h-[530px] 11xl:w-[1680px] 11xl:h-[1050px] rounded"
            src="https://www.youtube.com/embed/yc6lg5h6M0g"
            title="YouTube video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
            allowFullScreen
          ></iframe>
        </div>
        <div>
          <div className="5xl:block hidden ">
            <h1 className="font-merienda px-5  mt-6 text-[27px] 8xl:text-4xl 10xl:text-5xl 11xl:text-8xl ">Our Story</h1>
            <img className="w-[200px] 8xl:w-[230px] 10xl:w-[320px] 11xl:w-[560px] 8xl:h-10" src={Rope} alt="Rope" />
          </div>

          <div className="px-3 2xl:px-7 4xl:px-10 ">
            <div className="flex justify-center">
              <img className="w-[80px] md:w-[100px] 8xl:w-[140px] 10xl:w-[180px] 11xl:w-[230px]" src={Logo} alt="Rope" />
            </div>
            <h3 className="font-semibold 8xl:text-2xl 9xl:text-3xl 10xl:text-4xl 11xl:text-7xl  text-center mt-6 mb-4">
              Welcome to PR Silks Sarees – A Legacy of Elegance & Tradition!
            </h3>
            <p className=" 8xl:text-lg 9xl:text-xl 10xl:text-2xl 11xl:text-6xl">
              At PR Silks, we celebrate the rich heritage of Indian
              craftsmanship by offering the finest Thiruppuvanam Silk Sarees—a
              true symbol of tradition and elegance. In addition to our
              signature silks, we also bring you a diverse collection of Cotton
              Sarees, Silk Cotton Sarees, and more, perfect for every
              occasion—weddings , receptions, temple visits, and festive
              celebrations. Explore our collection on our website or connect
              with us on WhatsApp for exclusive designs. Let us help you find
              the perfect saree for your special moments!
              <br />
              <span></span> PR Silks – Where Tradition Meets Timeless Beauty!
            </p>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 lg:flex md:justify-around items-center mt-10 flex-wrap -gap-x-6 gap-y-8">
        <div>
          <img className="w-16 mx-auto md:w-24 9xl:w-32 11xl:w-44 " src={Logo1} alt="Rope" />
          <p className="text-center text-secondary  text-xs 3xl:text-md 5xl:text-xl 10xl:text-2xl 11xl:text-4xl mt-4">SHIPPING</p>
          <p className="text-center text-secondary text-xs 3xl:text-md 5xl:text-xl 10xl:text-2xl 11xl:text-4xl">WORLD WIDE</p>
        </div>
        <div>
          <img className="w-16 mx-auto md:w-24 9xl:w-32 11xl:w-44" src={Logo2} alt="Rope" />
          <p className="text-center text-secondary text-xs 3xl:text-md 5xl:text-xl 10xl:text-2xl 11xl:text-4xl mt-4">ORIGINAL</p>
          <p className="text-center text-secondary text-xs 3xl:text-md 5xl:text-xl 10xl:text-2xl 11xl:text-4xl">SILKS</p>
        </div>
        <div>
          <img className="w-16 mx-auto md:w-24 9xl:w-32 11xl:w-44" src={Logo3} alt="Rope" />
          <p className="text-center text-secondary text-xs 3xl:text-md 5xl:text-xl 10xl:text-2xl 11xl:text-4xl mt-4">BEST PRICE</p>
          <p className="text-center text-secondary text-xs 3xl:text-md 5xl:text-xl 10xl:text-2xl 11xl:text-4xl">PROMISE</p>
        </div>
        <div>
          <img
            className="w-24 mx-auto  md:w-32  5xl:w-32 9xl:w-40 11xl:w-56 -mt-5"
            src={Logo4}
            alt="Rope"
          />
          <p className="text-center text-secondary text-xs 3xl:text-md 5xl:text-xl 10xl:text-2xl 11xl:text-4xl">EASY</p>
          <p className="text-center text-secondary text-xs 3xl:text-md 5xl:text-xl 10xl:text-2xl 11xl:text-4xl">RETURN</p>
        </div>
      </div>
    </div>
  );
};

export default About;
